import React, { useState, useContext, useEffect } from "react";
import styled from "@emotion/styled";
import cookies from "cookies-js";
import { cookiesWork } from "@src/utils/cookies";
import { useLocation } from "@reach/router";
import { AppDataContext } from "@src/components/AppDataContext";
import { LocalStorageWrapper } from "@src/utils/localStorage";
import window from "global/window";

const TrackingPixelVessel = styled.img`
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
`;

type TrackingPixelsProps = {
  targetingCookieConsent: boolean;
};
const TrackingPixels: React.FC<TrackingPixelsProps> = ({ targetingCookieConsent }) => {
  const appData = useContext(AppDataContext);
  const [showFacebookPixel, setShowFacebookPixel] = useState(false);
  const [showPinterestPixel, setShowPinterestPixel] = useState(false);
  const [showFacebookSignInPixel, setShowFacebookSignInPixel] = useState(false);

  const searchParams = useLocation().search;
  const referrer = window.document ? window.document.referrer : null;
  const sessionIdCookie = cookiesWork() ? cookies.get("dojo_log_session_id") : null;
  const paramsEntries = new URLSearchParams(searchParams);
  const paramsAsObject = Object.fromEntries(paramsEntries);
  const initReferrerObjectInLocalStorage = LocalStorageWrapper.getItem("init-referrer-data");
  const lastReferrerObjectInLocalStorage = LocalStorageWrapper.getItem("last-referrer-data");

  function writeReferralData(localStorageKey: string) {
    const referrerObject = { sessionIdCookie: sessionIdCookie, ...paramsAsObject, referrerUrl: referrer };
    const referrerObjectAsString = JSON.stringify(referrerObject);
    LocalStorageWrapper.setItem(localStorageKey, referrerObjectAsString);
  }

  useEffect(() => {
    if (sessionIdCookie) {
      if (!initReferrerObjectInLocalStorage) {
        writeReferralData("init-referrer-data");
      }

      if (
        initReferrerObjectInLocalStorage &&
        sessionIdCookie !== JSON.parse(initReferrerObjectInLocalStorage).sessionIdCookie
      ) {
        writeReferralData("last-referrer-data");
      } else if (
        lastReferrerObjectInLocalStorage &&
        sessionIdCookie !== JSON.parse(lastReferrerObjectInLocalStorage).sessionIdCookie
      ) {
        LocalStorageWrapper.removeItem("last-referrer-data");
        writeReferralData("last-referrer-data");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionIdCookie]);

  function checkTrackingPixel() {
    if (!cookiesWork()) return;

    if (!cookies.get("attribution") && searchParams.match(/utm_campaign/) && searchParams.match(/utm_source/)) {
      const campaignSource = searchParams.match(/utm_source=[a-z]+/)?.[0].split("=")[1];
      cookies.set("attribution", campaignSource);
    }

    if (cookies.get("attribution") == "facebook" && !showFacebookPixel) setShowFacebookPixel(true);
    if (cookies.get("attribution") == "pinterest" && !showPinterestPixel) setShowPinterestPixel(true);
  }

  checkTrackingPixel();

  useEffect(() => {
    const isTeacher = appData.data.type === "teacher";
    if (isTeacher && targetingCookieConsent) {
      setShowFacebookSignInPixel(true);
    }
  }, [targetingCookieConsent, appData]);

  return (
    <>
      {showFacebookPixel && <TrackingPixelVessel src="https://www.facebook.com/tr?id=172748793147724&ev=PageView" />}
      {showPinterestPixel && (
        <TrackingPixelVessel src="https://ct.pinterest.com/v3/?tid=2612583504841&event=PageVisit&noscript=1" />
      )}
      {showFacebookSignInPixel && <TrackingPixelVessel src="https://www.facebook.com/tr?id=172748793147724&ev=Lead" />}
    </>
  );
};

export default TrackingPixels;
